<t4-list-view #listVw [options]="listOptions" (onDataRequest)="doPage($event)">
  <ng-container *t4ListItem="let item">
    <td>{{ item.DiscountName }}</td>
    <td>{{ item.Amount | localCurrency }}</td>
    @if (isInEditMode) {
      <td><button (click)="removeDiscountCode(item)" class="btn btn-danger">{{'SALES.ORDERS.DETAILS.BTN.REMOVE-DISCOUNT-CODE' | translate | uppercase}}</button></td>
    }
  </ng-container>
</t4-list-view>
